import { render, staticRenderFns } from "./DownloadCancelAndNew.vue?vue&type=template&id=01a05345&scoped=true"
import script from "./DownloadCancelAndNew.vue?vue&type=script&lang=js"
export * from "./DownloadCancelAndNew.vue?vue&type=script&lang=js"
import style0 from "./DownloadCancelAndNew.vue?vue&type=style&index=0&id=01a05345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a05345",
  null
  
)

export default component.exports